import React from 'react';
import { motion } from 'framer-motion';
const BONUSES = [{
  id: 1,
  img: 'https://cdn.magicpatterns.com/uploads/a48B1Rzg1dTE4jnUHsb5G8/bono_1_p9.png',
  alt: 'Bonus 1: Protocolo Express'
}, {
  id: 2,
  img: 'https://cdn.magicpatterns.com/uploads/j2Wz8tht5UifrWFH1cq7Pd/bono_2_p9.png',
  alt: 'Bonus 2: Mini Guía Validante'
}, {
  id: 3,
  img: 'https://cdn.magicpatterns.com/uploads/8X97E1xf3qr4EP6ZMP1yqp/bono_3_p9.png',
  alt: 'Bonus 3: Guía de Frases Reguladas'
}, {
  id: 4,
  img: 'https://cdn.magicpatterns.com/uploads/19Xue3za1igjbfxrEDqeYA/bono_4_p9.png',
  alt: 'Bonus 4: Ritual de Cierre Nocturno'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="py-12 px-4" data-id="element-1">
      <div className="text-center mb-10" data-id="element-2">
        <motion.span initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} className="inline-block bg-gradient-to-r from-pink-500 to-purple-600 text-white px-6 py-2 rounded-full font-bold text-lg shadow-lg mb-4 animate-pulse" data-id="element-3">
          🎁 GRATIS POR EL DÍA DE HOY
        </motion.span>
        <h3 className="text-2xl md:text-3xl font-bold text-purple-900 mt-4" data-id="element-4">
          Llevate estos 4 regalos exclusivos con tu compra
        </h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto" data-id="element-5">
        {BONUSES.map((bonus, index) => <motion.div key={bonus.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="cursor-pointer transform transition-transform hover:scale-105" onClick={scrollToPurchase} data-id="element-6">
            <img src={bonus.img} alt={bonus.alt} className="w-full h-auto rounded-xl shadow-xl border-2 border-purple-100" data-id="element-7" />
          </motion.div>)}
      </div>
    </div>;
}